/**
 * Routes list
 * Orgstructure API
 */
let _prefix = '/orgstructure/v1'
let _prefixMail = '/mail/v1'

export default {
  company: _prefix + '/company',
  check: _prefix + '/companies-posts',
  // Check post id access
  checkAccess: _prefix + '/check-access',
  
  // Информация о постах и компаниях
  entitiesInfo: _prefix + '/entities-info',
  
  // OrgStructure TREE. Тип дерева передается параметром. Убрал bp. По умолчанию type = standart
  tree: _prefix + '/tree', // GET
  shortTree: _prefix + '/optional-tree',
  trees: _prefix + '/trees',
  treePosts: _prefix + '/tree-posts',
  // Доступные компании
  companies: _prefix + '/companies-posts',
  
  postList: _prefix + "/posts-list/{containerId}", // GET
  
  // Логотип поста
  postLogo: _prefix + '/post-logo',
  
  // Доступные интерфейсы
  accessInterfaces: '/interfaces/v1/access_interfaces',
  
  scheme: _prefix + '/orgstructure-tree',
  invite: _prefix + '/invite',
  dismiss: _prefix + '/dismiss',
  container: _prefix + '/container',
  post: _prefix + '/post',
  type: _prefix + '/type',
  logo: _prefix + '/logo',
  element: _prefix + '/element',
  change_position_container: _prefix + '/change-position-container',
  change_position_post: _prefix + '/change-position-posts',
  
  deleted_posts: _prefix + '/deleted-posts',
  post_emails: _prefixMail + '/contacts'
}



// WEBPACK FOOTER //
// ./src/apps/org/api/orgstructure/routes.js